module.exports = __webpack_public_path__ + "img/last_screen.4383c6ea.gif";